import * as yup from 'yup';

export const validateOrderSchema = yup.object({
  order_number: yup.string().required('Order number is required.'),
});
